import { Loader } from '../loader/Loader'
import { Header } from '../header/Header'

const Lab = () => {
  return (
    <div>
      <Header title='Lab' withLogo />
      <div className='container min-w-full min-h-full flex flex-col items-center justify-center'>
        <div className='flex flex-col items-center'>
          <Loader />
        </div>
      </div>
    </div>
  )
}

export { Lab }
